import React from 'react';
import { SectionReveal } from './ui/SectionReveal';
import { Button } from './ui/Button';
import { useLanguage } from '../context/LanguageContext';
type PhaseKey = 'p1' | 'p2' | 'p3' | 'p4';
type StatusKey = 'sold' | 'available' | 'soon';
type BtnKey = 'viewProject' | 'viewAvailable' | 'notify';
const phases: Array<{
  key: PhaseKey;
  statusKey: StatusKey;
  statusColor: string;
  dotColor: string;
  btnKey: BtnKey;
  btnVariant: 'primary' | 'secondary';
}> = [{
  key: 'p1',
  statusKey: 'sold',
  statusColor: 'bg-red-100 text-red-800',
  dotColor: 'bg-red-500',
  btnKey: 'viewProject',
  btnVariant: 'secondary'
}, {
  key: 'p2',
  statusKey: 'available',
  statusColor: 'bg-green-100 text-green-800',
  dotColor: 'bg-green-500',
  btnKey: 'viewAvailable',
  btnVariant: 'primary'
}, {
  key: 'p3',
  statusKey: 'soon',
  statusColor: 'bg-orange-100 text-orange-800',
  dotColor: 'bg-orange-500',
  btnKey: 'notify',
  btnVariant: 'secondary'
}, {
  key: 'p4',
  statusKey: 'soon',
  statusColor: 'bg-orange-100 text-orange-800',
  dotColor: 'bg-orange-500',
  btnKey: 'notify',
  btnVariant: 'secondary'
}];
export function PhasesSection() {
  const {
    t
  } = useLanguage();
  const scrollTo = (href: string) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <SectionReveal id="fases" className="bg-light" data-id="element-307" data-mp="ufb4xpxwboeb">
      <div className="container mx-auto px-6 md:px-12" data-id="element-308" data-mp="pg6z99a6k8sq">
        <div className="text-center mb-12" data-id="element-309" data-mp="phhziz4f2yf3">
          <span className="inline-block text-nature text-sm font-semibold tracking-[0.2em] uppercase mb-4" data-id="element-310" data-mp="14536530i3frr">
            {t.phases.tag}
          </span>
          <h2 className="text-4xl md:text-5xl font-serif text-navy mb-5" data-id="element-311" data-mp="zcjrs3tzoglw">
            {t.phases.title}
          </h2>
          <div className="w-20 h-[2px] bg-nature mx-auto" data-id="element-312" data-mp="blxjqcjziwbw"></div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 max-w-5xl mx-auto" data-id="element-313" data-mp="6oxdo1n4xtks">
          {phases.map((phase, index) => <div key={index} className="group relative bg-nature text-white p-4 rounded-xl shadow-lg flex flex-col h-full overflow-hidden transition-transform duration-300 hover:-translate-y-1" data-id="element-314" data-mp="2bq9qr46hps92" data-mpi={index}>
              {/* Large faded phase number */}
              <span aria-hidden="true" className="absolute -top-2 right-2 text-[3.5rem] font-serif font-bold leading-none text-white/5 select-none" data-id="element-315" data-mp="1nskmkaek04zt">
                {index + 1}
              </span>

              <h3 className="relative text-lg font-serif font-bold mb-3 text-white" data-id="element-316" data-mp="1wshfwpbw1s17">
                {t.phases.phases[phase.key].name}
              </h3>

              <div className="relative space-y-3 flex-grow" data-id="element-317" data-mp="388fu17lxb49a">
                <div data-id="element-318" data-mp="387wf7zrkkvzh">
                  <p className="text-[10px] uppercase tracking-wider text-white/50 mb-1.5" data-id="element-319" data-mp="38as8vbwdwyi4">
                    {t.phases.labels.status}
                  </p>
                  <div className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[11px] font-bold ${phase.statusColor}`} data-id="element-320" data-mp="3na4ib9ur1b15">
                    <div className={`w-1.5 h-1.5 rounded-full ${phase.dotColor}`} data-id="element-321" data-mp="3dkuq7tzwnsd1"></div>
                    {t.phases.status[phase.statusKey]}
                  </div>
                </div>

                <div data-id="element-322" data-mp="34mizzt2yawl4">
                  <p className="text-[10px] uppercase tracking-wider text-white/50 mb-0.5" data-id="element-323" data-mp="34iv9l2ssyqam">
                    {t.phases.labels.delivery}
                  </p>
                  <p className="text-sm font-medium text-white" data-id="element-324" data-mp="2unjqy9e9wyxl">
                    {t.phases.phases[phase.key].delivery}
                  </p>
                </div>
              </div>

              <div className="relative mt-4 pt-3 border-t border-white/10" data-id="element-325" data-mp="svorcs5akkvq">
                <Button variant={phase.btnVariant} className="w-full" onClick={() => scrollTo(phase.statusKey === 'available' ? '#disponibilidad' : '#contacto')} data-id="element-326" data-mp="ou3c505abuid">
                  {t.phases.buttons[phase.btnKey]}
                </Button>
              </div>
            </div>)}
        </div>
      </div>
    </SectionReveal>;
}